export const SIDEBAR_OPEN = "SIDEBAR_OPEN";
export const SIDEBAR_CLOSE = "SIDEBAR_CLOSE";
export const NAVBAR_OPEN = "NAVBAR_OPEN";
export const NAVBAR_CLOSE = "NAVBAR_CLOSE";
export const NOTIFICATION_OPEN = "NOTIFICATION_OPEN";
export const NOTIFICATION_CLOSE = "NOTIFICATION_CLOSE";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const FILTER_PLAYERS = "FILTER_PLAYERS";
export const LOAD_PLAYERS = "LOAD_PLAYERS";
export const GET_PLAYERS_BEGIN = "GET_PLAYERS_BEGIN";
export const GET_PLAYERS_SUCCESS = "GET_PLAYERS_SUCCESS";
export const GET_PLAYERS_ERROR = "GET_PLAYERS_ERROR";
export const GAMES_DETAIL_CLOSE = "GAMES_DETAIL_CLOSE";
export const GAMES_DETAIL_OPEN = "GAMES_DETAIL_OPEN";

export const REG_LOADING_IN_PROGRESS = "REG_LOADING_IN_PROGRESS";
export const REG_LOADING_ERROR = "REG_LOADING_ERROR";
export const REG_LOADING_COMPLETED = "REG_LOADING_COMPLETED";
export const REG_UPDATED = "REG_UPDATED";
export const REG_FILTER = "REG_FILTER";
export const REG_RESET_FILTER = "REG_RESET_FILTER";
export const REG_UPDATE_TOURNAMENT = "REG_UPDATE_TOURNAMENT";
export const REG_UPDATE_TOURNAMENT_NOGROUP = "REG_UPDATE_TOURNAMENT_NOGROUP";

export const REG_GRP_LOADING_IN_PROGRESS = "REG_GRP_LOADING_IN_PROGRESS";
export const REG_GRP_LOADING_ERROR = "REG_GRP_LOADING_ERROR";
export const REG_GRP_LOADING_COMPLETED = "REG_GRP_LOADING_COMPLETED";
export const REG_GRP_UPDATED = "REG_GRP_UPDATED";

export const SEASON_GRP_LOADING_IN_PROGRESS = "SEASON_GRP_LOADING_IN_PROGRESS";
export const SEASON_GRP_LOADING_ERROR = "SEASON_GRP_LOADING_ERROR";
export const SEASON_GRP_LOADING_COMPLETED = "SEASON_GRP_LOADING_COMPLETED";
export const SEASON_GRP_UPDATED = "SEASON_GRP_UPDATED";

export const SET_AUTH_TOKENS = "SET_AUTH_TOKENS";
export const REFRESH_USER = "REFRESH_USER";
export const SET_USER = "SET_USER";

export const UPDATE_MATCH = "UPDATE_MATCH";
export const UPDATE_MATCH_GAME_IDS = "UPDATE_MATCH_GAME_IDS";
export const LOAD_MATCH = "LOAD_MATCH";
export const MATCH_LOADING_IN_PROGRESS = "MATCH_LOADING_IN_PROGRESS";
export const MATCH_LOADING_COMPLETED = "MATCH_LOADING_COMPLETED";
export const MATCH_LOADING_ERROR = "MATCH_LOADING_ERROR";

export const MATCH_UPDATING_IN_PROGRESS = "MATCH_UPDATING_IN_PROGRESS";
export const MATCH_UPDATING_COMPLETED = "MATCH_UPDATING_COMPLETED";
export const MATCH_UPDATING_ERROR = "MATCH_UPDATING_ERROR";
